export default __webpack_public_path__ + "static/media/earn.2932df81.svg";